import MetalsMinerals from "./MetalsMinerals.jsx";
export default MetalsMinerals